module.exports = __webpack_public_path__ + "static/img/noun_play_3535575.0b55a58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/noun_play_3535575.png
// module id = x4jz
// module chunks = 1